const actions = {
    GET_DATA: "GET_DATA",
    GET_DATA_SUCCESS: "GET_DATA_SUCCESS",
    GET_DATA_IS_LOADING: "GET_DATA_IS_LOADING",
    GET_DATA_HAS_ERROR: "GET_DATA_HAS_ERROR",
};

function authenticatedRequest( url, id ) {
    return ( dispatch ) => {
        dispatch( requestIsLoadingAction( true, id ) );
        fetch( url )
            .then( ( response ) => {
                if ( !response.ok ) {
                    throw Error( response );
                }

                dispatch( requestIsLoadingAction( false, id ) );
                return response;
            } )
            .then( response => response.json() )
            .then( ( data ) => {
                dispatch( requestSuccessAction( data, id ) );
            } )
            .catch( ( error ) => {
                dispatch( requestErrorAction( error, id ) );
            } )
    }
}

function requestSuccessAction( data, id ) {
    return {
        type: actions.GET_DATA_SUCCESS,
        id,
        data,
    }
}

function requestIsLoadingAction( loading, id ) {
    return {
        type: actions.GET_DATA_IS_LOADING,
        id,
        loading,
    }
}

function requestErrorAction( error, id ) {
    return {
        type: actions.GET_DATA_HAS_ERROR,
        id,
    }
}

function requestHasData( props ) {
    return !! ( props.requests && props.requests.get && props.requests.get.data );
}

function getRequestContent( props, id ) {
    return props.requests.get.data;
}

module.exports = {
    authenticatedRequest,
    actions,
    requestHasData,
    getRequestContent,
};



// WEBPACK FOOTER //
// src/client/actions/requests/get.js